import { render, staticRenderFns } from "./pendingRenew.vue?vue&type=template&id=71861a97&scoped=true&"
import script from "./pendingRenew.vue?vue&type=script&lang=js&"
export * from "./pendingRenew.vue?vue&type=script&lang=js&"
import style0 from "../style.scss?vue&type=style&index=0&id=71861a97&prod&lang=scss&scoped=true&"
import style1 from "./pendingRenew.vue?vue&type=style&index=1&id=71861a97&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71861a97",
  null
  
)

export default component.exports